import api from './api.service'
import storage from './stoage.service'
import jwt from 'jsonwebtoken'

const isAuthenticated = () => {
  const token = storage.getToken()
  if (!token) {
    return false
  }
  try {
    // So le o token para saber se ainda esta no prazo: a assinatura quem confere e o back, a cada
    // requisicao. Ate 10/2026 o front verificava com a chave 'secret' fixa aqui, que ia para o
    // navegador de todo usuario; com a chave real so no servidor, o verify recusaria todo token (PHOENIX-959).
    const decoded = jwt.decode(token)
    return Boolean(decoded && decoded.exp && decoded.exp * 1000 > Date.now())
  } catch (err) {
    return false
  }
}

const login = (credential) => {
  return api.post('/lottustech/login', credential).then((response) => {
    const { data } = response
    storage.setToken(data.token)
    storage.setUser(data.login)
    storage.setOidUser(data.oidUsuario)
    storage.setCompany(data.empresa)
    storage.setAppLabels(data.appLabels)
    storage.setAlteraUnidade(data.alteraUnidade)
    storage.setVersaoSistema(data.versaoSistema)
    storage.setMenuLayout(data.menuLayout)
    return Promise.resolve(response)
  })
}

const loginPortalCliente = (credential) => {
  return api.post('/lottustech/portalcliente/login', credential).then((response) => {
    const { data } = response
    storage.setToken(data.token)
    storage.setUser(data.login)
    storage.setOidUser(data.oidUsuario)
    storage.setCompany(data.empresa)
    storage.setAppLabels(data.appLabels)
    storage.setAlteraUnidade(false)
    storage.setVersaoSistema(data.versaoSistema)
    return Promise.resolve(response)
  })
}

// o envio do e-mail acontece dentro da requisicao: sem timeout uma falha de SMTP deixava a tela
// carregando para sempre
const TIMEOUT_ESQUECI_SENHA = 30000

const esquecisenha = (login) => {
  return api
    .post(`/lottustech/public/esquecisenha`, login, { timeout: TIMEOUT_ESQUECI_SENHA })
    .then((response) => {
      return Promise.resolve(response)
    })
}
const criarConta = (conta) => {
  return api.post(`/lottustech/public/criarconta`, conta).then((response) => {
    return Promise.resolve(response)
  })
}

const redefinirSenha = (dados) => {
  return api.post(`/lottustech/public/redefinirsenha`, dados).then((response) => {
    return Promise.resolve(response)
  })
}

const logout = () => {
  return api.post('/lottustech/logout').then(() => {})
}

const getDefaultCompany = () => {
  return storage.getCompany()
}

const getUserName = () => {
  return storage.getUser()
}

export default {
  isAuthenticated,
  login,
  loginPortalCliente,
  logout,
  getDefaultCompany,
  getUserName,
  criarConta,
  esquecisenha,
  redefinirSenha,
}
